// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Contact_wrapper__wcVuN","icon":"Contact_icon__wUZr_","title":"Contact_title__18Z0u","description":"Contact_description__fQB3P"};